function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "75px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "M0 0L0 75L76 75L76 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M31 5L31 21L33 21L33 5L31 5M39 9L39 21L41 21L41 9L39 9M23 13L23 21L25 21L25 13L23 13M47 13L47 21L49 21L49 13L47 13M14 23L14 55C14.0003 59.355 13.2676 64.962 16.6528 68.3472C20.4104 72.1049 27.1862 71 32 71C44.059 71 57.8579 73.898 58 58C73.367 56.2884 73.367 33.7116 58 32L58 23L14 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d5e0",
      stroke: "none"
    },
    d: "M18 27L18 54C18 57.1561 17.179 61.9116 19.0278 64.6821C20.5759 67.0021 23.5158 66.9486 26 66.9954C31.6175 67.1011 49.5414 69.8235 52.9722 64.6821C54.821 61.9116 54 57.1561 54 54L54 27L18 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 31.3333L59.3333 31.6667L58.6667 31.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d5e0",
      stroke: "none"
    },
    d: "M58 35L58 55C68.3464 51.4506 68.3464 38.5494 58 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M23 36L23 40L25 40L25 36L23 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 41L70 42L69 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M23 43L23 63L25 63L25 43L23 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 48L70 49L69 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 58.3333L59.3333 58.6667L58.6667 58.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M14 65L15 66L14 65M57 65L58 66L57 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M15 67L16 68L15 67M56 67L57 68L56 67M17 69L18 70L17 69M54 69L55 70L54 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M19 70L20 71L19 70M52 70L53 71L52 70z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.0ad01431bf704ffb7f2c0b91f7336959.svg";
export { ForwardRef as ReactComponent };